module.exports = __webpack_public_path__ + "static/img/默认的图标.182bc49.png";


//////////////////
// WEBPACK FOOTER
// ./src/wenxing/assets/images/默认的图标.png
// module id = AlCM
// module chunks = 70